import type { EnvironmentConnectionPhase } from "../connection/presentation.ts";
import type { ServerConfig } from "@heydex/contracts";

export function canCreateProjectInEnvironment(
  connectionPhase: EnvironmentConnectionPhase | null | undefined,
): boolean {
  return connectionPhase === "connected";
}

/**
 * The Scratch folder an environment offers threads without a project right
 * now, or null while it is not connected or has none.
 */
export function availableScratchWorkspaceRoot(
  connectionPhase: EnvironmentConnectionPhase | null | undefined,
  serverConfig: Pick<ServerConfig, "scratchWorkspaceRoot"> | null | undefined,
): string | null {
  return canCreateProjectInEnvironment(connectionPhase)
    ? (serverConfig?.scratchWorkspaceRoot ?? null)
    : null;
}
